/**
 * Checks if the array is empty
 */
const isEmpty = (arr: any[]) => arr.length < 1;
export default isEmpty;
